import API from "Api";
import {
  LOGIN_USER_ENDPOINT,
  LOGOUT_USER_ENDPOINT,
  FORGOT_PASSWORD_ENDPOINT,
  RESET_PASSWORD_ENDPOINT,
  CHECK_RESET_PASSWORD_LINK,
  CHECK_CREATE_PHARMACY_PASSWORD,
} from "Api/endpoints";

export const loginUserAPI = async (signinData) => {
  return await API.post(LOGIN_USER_ENDPOINT, signinData);
};

export const forgotPasswordAPI = async (email) => {
  return await API.post(FORGOT_PASSWORD_ENDPOINT, { email });
};

export const resetPasswordAPI = async (payload, token) => {
  return await API.post(RESET_PASSWORD_ENDPOINT, payload, token);
};

export const checkResetPassoword = async (token) => {
  return await API.get(CHECK_RESET_PASSWORD_LINK.replace("##TOKEN##", token));
};

export const logoutUserAPI = async () => {
  return await API.post(LOGOUT_USER_ENDPOINT);
};

export const createPharmacyPasswordAPI = async (payload, token) => {
  return await API.post(CHECK_CREATE_PHARMACY_PASSWORD, payload, token);
};
